import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Blocker } from "react-router";

type Props = {
    blocker: Blocker;
};

export default function GaiaConfirmCloseDialog({ blocker: { state, reset, proceed } }: Props) {
    const { t } = useTranslation("app");

    return (
        <Dialog open={state === "blocked"} onClose={reset}>
            <DialogTitle>{t("gaiaConfirmCloseDialog.title")}</DialogTitle>
            <DialogContent>
                <DialogContentText>{t("gaiaConfirmCloseDialog.description")}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={reset} autoFocus>
                    {t("gaiaConfirmCloseDialog.cancel")}
                </Button>
                <Button onClick={proceed}>{t("gaiaConfirmCloseDialog.proceed")}</Button>
            </DialogActions>
        </Dialog>
    );
}
